export const apiAdapter = {
    'regByEmail': 'reg/regByEmail',
    'regByMobile': 'reg/regByMobileCaptcha',
    'loginByCaptcha': 'login/imgControl/loginByCaptcha',
    'loginByPassport': 'login/loginByPassport',
    'mobileHasBind': 'passport/hasMobile',
    'getUserInfo': 'passport/getUserInfo',
    'passportHasMobile': 'passport/hasMobile',
    'regCheck': 'passport/regCheck',
    'modifyBind': 'mobile/modifyBind',
    'bindMobile': 'mobile/bindMobile',
    'sendEmailCaptcha': 'mobile/modifyBind',
    'verifyOriginalBind': 'mobile/verifyOriginalBind',
    'vertifyMobileCaptcha': 'captcha/vertifyMobileCaptcha',
    'getMobileCaptcha': 'captcha/secure/getMobileCaptcha',
    'getMobileCaptchaTx': 'captcha/secure/tx/getMobileCaptcha',
    'getCaptcha': 'imgcode/getCaptcha',
    'verifyCaptcha': 'imgcode/verifycaptcha',
    'isNeeded': 'imgcode/isNeeded',
    'modifyWithOldPwd': 'password/modifyWithOldPwd',
    'verifyOldPwd': 'password/modifyWithOldPwd',
    'resetByMobile': 'password/resetByMobile',
    'resetByEmail': 'password/resetByEmail',
    'passwordVerifyCaptcha': 'password/verifyCaptcha',
    'sendVerifyEmail': 'password/sendVerifyEmail'
};

export const typeAdapter = {
    'regByEmail': 'post',
    'regByMobile': 'post',
    'loginByCaptcha': 'post',
    'loginByPassport': 'post',
    'mobileHasBind': 'get',
    'getUserInfo': 'get',
    'passportHasMobile': 'get',
    'regCheck': 'get',
    'modifyBind': 'post',
    'bindMobile': 'post',
    'sendEmailCaptcha': 'post',
    'verifyOriginalBind': 'post',
    'vertifyMobileCaptcha': 'post',
    'getMobileCaptcha': 'get',
    'getCaptcha': 'get',
    'verifyCaptcha': 'post',
    'isNeeded': 'get'
};



// WEBPACK FOOTER //
// ./src/model/proxy/passportAdapter.js